import axios from "./axios-config";

export const submitFormData = async (data:any) => {
    const url = `/api/request-account/submit`;
    return await axios.post(url,data);
}

export const submitFormDataToTestDb = async (data:any) => {
    const url = `/api/request-account/submit-to-test-db`;
    return await axios.post(url,data);
}

export const sendOTP = async (data: any) => {
    const url = `api/request-account/send-otp`;
    return await axios.post(url,data);
}

export const verifyOTP = async (data: any) => {
    const url = `api/request-account/verify-otp`;
    return await axios.post(url,data);
}

export const checkExistingUsers = async (data: any) => {
    const url = `api/checkuser`;
    return await axios.post(url,data);
}